import styled from 'styled-components';

export const ResendCode = styled.div`
  display: flex;
  align-items: center;

  button {
    background: transparent;
    border: none;

    font-size: 16px;
    color: ${({ theme }) => theme.colors.primary};
    margin-left: 10px;
  }

  @media (max-width: ${({ theme }) => theme.gridBreakpoints.sm}) {
    justify-content: center;
  }
`;
